import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../store';
import InnerLoading from '../ui/InnerLoading';
import { fetchTripDetails } from '../../features/admin/tripSlice';
import { FaStar, FaMapMarkerAlt, FaEdit } from 'react-icons/fa';

const TripDetails = () => {
	const { tripId } = useParams<{ tripId: string }>();
	const { t } = useTranslation();

	const dispatch = useDispatch<AppDispatch>();
	const { trip, loading } = useSelector((state: RootState) => state.tripSlice);

	useEffect(() => {
		if (tripId) {
			dispatch(fetchTripDetails({ tripId: parseInt(tripId) }));
		}
	}, [tripId, dispatch]);

	if (loading) return <InnerLoading />;
	if (!trip) return <p>{t('trip-not-found')}</p>;
	return (
		<div >
			<div className='bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6'>
				<h2 className='text-white text-lg font-semibold'>{t("trip-details")}</h2>
			</div>
			<div className='bg-white p-4'>
				<div className="grid  xs:grid-cols-1 md:grid-cols-2 gap-4 text-gray-700 w-full">
					<p><strong>{t('trip-name')}:</strong> {trip?.fromLocation} - {trip?.toLocation}</p>
					<p><strong>{t('trip-price')}:</strong> {trip?.price} {trip?.currencyCode}</p>

					<p>
						<strong>{t('trip-start-date')}:</strong>{' '}
						{trip?.fromDate ? new Date(trip.fromDate).toLocaleDateString() : '--'}

					</p>
					<p>
						<strong>{t('trip-end-date')}:</strong>{' '}
						{trip?.toDate ? new Date(trip.toDate).toLocaleDateString() : '--'}
					</p>
					<p className=' flex items-center gap-1'>
						<strong>{t('trip-rate')}:</strong>
						{trip?.rate != null ? (trip.rate % 1 === 0 ? trip.rate : trip.rate.toFixed(1)) : '--'}{' '}
						<FaStar className="inline text-yellow-400" />
					</p>
					{trip?.link && <p ><strong>{t('trip-link')}:</strong> <a href={trip?.link} className="text-blue-600 underline break-all">{trip?.link}</a></p>}
					<p><strong>{t('trip-adults')}:</strong> {trip?.numberOfAdults}</p>
					<p><strong>{t('trip-children')}:</strong> {trip?.numberOfChilds}</p>
				</div>

				{trip && Array.isArray(trip.tripImages) && trip.tripImages.length > 0 && (
					<section className=" py-5">
						<h3 className="text-xl font-semibold mb-4">{t('trip-images')}</h3>
						<div className="grid grid-cols-2 md:grid-cols-4 gap-3">
							{trip.tripImages.map((img) => (
								<img key={img.id} src={img.url} alt="trip" className="rounded-xl w-full h-40 object-cover" />
							))}
						</div>
					</section>
				)}
				{trip?.place && (
					<section className=" p-6 w-full  space-y-4">
						<h2 className="text-xl font-semibold pb-4">{t('place-title')}</h2>
						<div className="grid md:grid-cols-2 gap-4 text-gray-700">
							<p><strong>{t('place-name')}:</strong> {trip?.place?.title}</p>
							<p><strong>{t('place-location')}:</strong> <FaMapMarkerAlt className="inline" /> {trip.place.location}</p>
							<p className="md:col-span-2">
								<strong className=' block'>{t('place-description')}:</strong>
								{trip.place.details}</p>
						</div>
						<div>
							<strong className="text-gray-700 block mb-2">{t('plcae-services')}</strong>
							<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
								{trip.place?.amenities.length === 0 && <div className=" text-textSecond">{t("no-services")}</div>}
								{trip.place?.amenities.map((amenity) => (
									<div key={amenity.id} className="flex items-center gap-3 bg-gray-100 p-3 rounded-lg">
										<img src={amenity.image} alt={amenity.title} className="w-6 h-6" />
										<span className="text-sm text-gray-800">{amenity.title}</span>
									</div>
								))}
							</div>
						</div>

						<div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
							{trip.place.images?.map((img) => (
								<img key={img.id} src={img.url} alt="place" className="rounded-xl w-full h-40 object-cover" />
							))}
						</div>
					</section>
				)}


				{trip && Array.isArray(trip.reviews) && trip.reviews.length > 0 && (
					<section className=" p-6 w-full">
						<h2 className="text-xl font-semibold pb-4">{t('reviews')}</h2>
						<div className="space-y-4 mt-4">
							{trip.reviews.map((review) => (
								<div key={review.id} className="border-b pb-3">
									<div className="flex items-center gap-3">
										<img src={review.userImage} alt="user" className="w-10 h-10 rounded-full" />
										<div>
											<p className="font-semibold">{review.userName}</p>
											<p className="text-yellow-500"><FaStar className="inline" /> {review.rating}</p>
										</div>
									</div>
									<p className="mt-2 text-gray-600">{review.comment}</p>
								</div>
							))}
						</div>
					</section>
				)}
			</div>
			<div className="flex justify-end w-full justify-self-end  pt-2">
				<Link to={`/dashboard/trip-modal/${trip?.id}`}
					className="flex items-center gap-1 text-sm px-3 py-1 bg-yellow-100 text-yellow-800 hover:bg-yellow-200 rounded"
				>
					<FaEdit /> {t("edit")}
				</Link>
			</div>
		</div>

	)
}

export default TripDetails